exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".general-item-list > .item:last-of-type {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.item.selectable {\r\n    cursor: pointer;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/add-ons/medication/addon-medication.component.css
// module id = 969
// module chunks = 1